import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ChartComponent } from './components/chart/chart.component';
import { PerformanceDataComponent } from './components/performance-data/performance-data.component';
import { PerformancePanelComponent } from './components/performance-panel/performance-panel.component';
import { ContractorStatisticComponent } from './components/contractor-statistic/contractor-statistic.component';
import { StatisticOverviewComponent } from './components/statistic-overview/statistic-overview.component';

const performanceRoutes: Routes =  [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'chart'
  },
  {
    path: 'chart',
    component: ChartComponent
  },
  {
    path: 'data',
    component: PerformanceDataComponent
  },
  {
    path: 'dashboard',
    component: PerformancePanelComponent
  },
  {
    path: 'statistic',
    component: ContractorStatisticComponent
  },
  {
    path: 'statistic/:statisticId',
    component: ContractorStatisticComponent
  },
  {
    path: 'overview',
    component: StatisticOverviewComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(performanceRoutes)
  ],
  exports: [RouterModule]
})
export class PerformanceRoutingModule { }
